import {updateSheetHistory} from "../store/reducers/availableSheets";
import Action from "./action";

export const updateUndoRedoState = (currObj, action, canvas, activeSheet, dispatch) => {
    let newAction = new Action(currObj ? currObj.id : '', action, canvas);

    dispatch(updateSheetHistory({
        sheetId: activeSheet.id,
        objectState: newAction
    }));
}